import React from 'react'
import ModalDetailComponent from '../components/ModalDetailComponent'
import { useDispatch, useSelector } from 'react-redux';
import { openDetail } from '../redux/slice/deviceSlice';

const FormDetailDevice = () => {
    const dispatch = useDispatch();
    const { dataDevices, isOpenDevice, isLoading, isOpenDetailDevice, dataByIdDevices } = useSelector( (state) => state.device );
    // console.log(dataByIdDevices)
  return (
    <ModalDetailComponent
    title="DETAIL DATA PERANGKAT"
    show={isOpenDetailDevice}
    close={() => dispatch(openDetail({ open: false, type: 'close' }))}
    idForm="detailCamera-form"
  >
      <div className="row" style={{ alignItems: 'center'}}>
          <div className="col-xl-6">
              <table className="table">
                  <thead>
                      {/* <tr>
                          <span> Detail Data Kamera </span>
                       </tr> */}
                  </thead>
                  <tbody>
                      <tr> ID Perangkat : {dataByIdDevices.devId} </tr>
                      <tr> Nama Perangkat :  {dataByIdDevices.devName} </tr>
                      <tr> Tipe Perangkat : {dataByIdDevices.devType} </tr>
                      <tr> Spesifikasi Perangkat : {dataByIdDevices.devSpecs} </tr>
                      <tr> IP Perangkat : {dataByIdDevices.devIp} </tr>
                      <tr> Operasi sistem Perangkat : {dataByIdDevices.devOs} </tr>
                      <tr> Longitude : {dataByIdDevices.devLon} </tr>
                  </tbody>
              </table>
          </div>
          <div className="col-xl-6">
              <tbody>
                  <tr> Latitude : {dataByIdDevices.devLat} </tr>
                  <tr> Altitude : {dataByIdDevices.devAlt} </tr>
                  <tr> Lokasi Perangkat :  {dataByIdDevices.devLocation} </tr>
                  <tr> Nama User Perangkat :  {dataByIdDevices.devUser} </tr>
                  <tr> Password Perangkat :  {dataByIdDevices.devPassword} </tr>
                  <tr> Port Perangkat :  {dataByIdDevices.devPort} </tr>
                  <tr> Bucket Perangkat :  {dataByIdDevices.devBucket} </tr>
              </tbody>
          </div>
      </div>
  </ModalDetailComponent>
  )
}

export default FormDetailDevice